import React from "react";
import {Link} from "react-router-dom";
import {BorgesTitle} from "./Borges";

function TheAmphisbaena() {
    return (
        <div className="row">
            <div className="col-md-8 offset-md-2">
                <h1 className="text-center"><Link to="/translation/borges/the-amphisbaena">The Amphisbaena</Link>
                </h1>
                <BorgesTitle/>
                <p>
                    The <em>Pharsalia</em> lists a number of real and imaginary serpents that Cato’s solders
                    faced in the African deserts; there’s the parca “that walks erect like a staff,” the
                    iaculus that shoots through the air like an arrow, and the lumbering two-headed amphisbaena.
                </p>
                <p>
                    Pliny describes the creature in nearly the same words, adding: “as though one head alone did
                    not suffice for discharging its venom.”
                </p>
                <p>
                    Brunetto Latini’s Tesoretto—the encyclopedia he recommended to his old student in the seventh
                    circle of Hell—is clearer and less sententious: “The amphisbaena is a two-headed serpent,
                    one in its normal place and the other on the tail; and it can bite with both heads, and
                    run with agility, and its eyes shine like candles.”
                </p>
                <p>
                    In the seventeenth century, Sir Thomas Browne observed that there is no animal without a top,
                    bottom, front, back, left and right, and thereby denied the possible existence of the
                    amphisbaena, who has two front sides.
                </p>
                <p>
                    In Greek, Amphisbaena means bidirectional.
                </p>
                <p>
                    In the Antilles and in certain parts of America, the name applies to a reptile commonly known
                    as the “double walker”, “two-headed serpent” or “mother of ants.” It’s said that it subsists
                    on ants. Also that, if you cut it into two pieces, these will join back together.
                </p>
                <p>
                    The medicinal virtues of the amphisbaena were celebrated as early as Pliny.
                </p>
                <p>
                    <strong>Jorge Luis Borges, from "Manual of Fastastic Zoology"</strong>
                </p>
                <p>
                    <em>Trans. Porter James, 2024-01-15</em>
                </p>
            </div>
        </div>
    );
}

export default TheAmphisbaena
